import { createHook } from '@atomify/hooks';

export const useMemoizedValue = <T>(getter: () => T) =>
    createHook({
        onDidLoad: () => {
            let value: T;
            return () => {
                if (!value) value = getter();
                return value;
            };
        },
    });
